/**
 * Landing Page — Skinroller Pro
 * UTM headline swap, scroll tracking, sticky CTA, exit intent
 */
(function () {
  'use strict';

  /* ==============================
     1. UTM HEADLINE SWAP
     ============================== */

  function swapHeadlines() {
    var params = new URLSearchParams(window.location.search);
    var angle = params.get('angle');
    if (!angle) return;

    var headlines = document.querySelectorAll('.lp-hero__headline, .tt-hero__headline');
    var subheadlines = document.querySelectorAll('.lp-hero__subheadline, .tt-hero__sub');

    headlines.forEach(function (el) {
      var newText = el.getAttribute('data-headline-' + angle);
      if (newText) el.textContent = newText;
    });
    subheadlines.forEach(function (el) {
      var newSub = el.getAttribute('data-subheadline-' + angle);
      if (newSub) el.textContent = newSub;
    });
  }

  /* ==============================
     2. SCROLL DEPTH TRACKING
     ============================== */

  function initScrollTracking() {
    var milestones = [25, 50, 75, 100];
    var fired = {};

    function getScrollPercent() {
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return 100;
      return Math.round((window.scrollY / docHeight) * 100);
    }

    function checkScroll() {
      var pct = getScrollPercent();
      milestones.forEach(function (m) {
        if (pct >= m && !fired[m]) {
          fired[m] = true;
          trackEvent('LP_Scroll_' + m, { scroll_depth: m });
        }
      });
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          checkScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ==============================
     3. STICKY MOBILE CTA
     ============================== */

  function initStickyCTA() {
    var stickyEl = document.querySelector('.lp-sticky-cta');
    if (!stickyEl) return;

    // Populate sticky CTA from tt-hero data attributes if present
    var ttHero = document.querySelector('[data-sticky-product]');
    if (ttHero) {
      var nameEl = stickyEl.querySelector('.lp-sticky-cta__text');
      var priceEl = stickyEl.querySelector('.lp-sticky-cta__price');
      var ctaBtn = stickyEl.querySelector('.lp-sticky-cta__btn');
      if (ctaBtn && ttHero.dataset.stickyPrice) ctaBtn.textContent = 'Testa nu – ' + ttHero.dataset.stickyPrice;

      // Set variant ID on header form + sticky CTA
      var vid = ttHero.dataset.stickyVariant;
      if (vid) {
        var headerInput = document.querySelector('.lp-header__variant-id');
        if (headerInput) headerInput.value = vid;

        // Convert sticky CTA link to form
        if (ctaBtn && ctaBtn.tagName === 'A') {
          var stickyForm = document.createElement('form');
          stickyForm.method = 'post';
          stickyForm.action = '/cart/add';
          stickyForm.innerHTML = '<input type="hidden" name="id" value="' + vid + '"><input type="hidden" name="quantity" value="1">';
          var newBtn = document.createElement('button');
          newBtn.type = 'submit';
          newBtn.className = ctaBtn.className;
          newBtn.textContent = ctaBtn.textContent;
          stickyForm.appendChild(newBtn);
          ctaBtn.parentNode.replaceChild(stickyForm, ctaBtn);
        }
      }
    }

    var heroSection = document.querySelector('.lp-hero') || document.querySelector('.tt-hero__media') || document.querySelector('.tt-hero');
    if (!heroSection) {
      stickyEl.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyEl.classList.remove('is-visible');
        } else {
          stickyEl.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(heroSection);
  }

  /* ==============================
     4. EXIT INTENT POPUP
     ============================== */

  function initExitIntent() {
    var overlay = document.querySelector('.lp-exit-overlay');
    if (!overlay) return;

    var shown = false;
    var sessionKey = 'lp_exit_shown';

    if (sessionStorage.getItem(sessionKey)) return;

    // Desktop: mouse leaves viewport
    document.addEventListener('mouseout', function (e) {
      if (shown) return;
      if (e.clientY <= 0 && e.relatedTarget === null) {
        showPopup();
      }
    });

    // Mobile: scroll up quickly after reaching 70%
    var lastScrollY = 0;
    var reached70 = false;
    window.addEventListener('scroll', function () {
      var pct = Math.round(
        (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
      );
      if (pct >= 70) reached70 = true;

      if (reached70 && !shown && window.scrollY < lastScrollY - 200) {
        showPopup();
      }
      lastScrollY = window.scrollY;
    }, { passive: true });

    function showPopup() {
      if (shown) return;
      shown = true;
      sessionStorage.setItem(sessionKey, '1');
      overlay.classList.add('is-active');
      trackEvent('LP_Exit_Intent');
    }

    // Close handlers
    var closeBtn = overlay.querySelector('.lp-exit-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        overlay.classList.remove('is-active');
      });
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        overlay.classList.remove('is-active');
      }
    });

    // Email submit
    var form = overlay.querySelector('.lp-exit-popup__form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('.lp-exit-popup__input');
        var email = input ? input.value.trim() : '';
        if (!email || !email.includes('@')) return;

        // Push to Klaviyo
        if (window._learnq) {
          window._learnq.push(['identify', { '$email': email, lp_source: 'skinroller_pro_exit' }]);
          window._learnq.push(['track', 'LP Email Capture', {
            source: 'exit_intent',
            page: window.location.pathname,
            email: email
          }]);
        }

        trackEvent('LP_Email_Capture', { source: 'exit_intent' });

        // Show success state with discount code
        var popup = overlay.querySelector('.lp-exit-popup');
        if (popup) {
          popup.innerHTML =
            '<div style="padding: 20px; text-align: center;">' +
            '<p style="font-size: 32px; margin: 0 0 12px;">🎉</p>' +
            '<p class="lp-exit-popup__heading heading-font">15% extra rabatt!</p>' +
            '<p style="color: rgba(0,0,0,0.6); font-size: 15px; margin: 0 0 16px;">Använd koden vid checkout:</p>' +
            '<p style="font-size: 24px; font-weight: 800; letter-spacing: 0.1em; background: #FFF0F3; padding: 14px 24px; border-radius: 12px; margin: 0 0 16px; user-select: all; cursor: pointer;" onclick="navigator.clipboard.writeText(\'GLOW15\')">GLOW15</p>' +
            '<p style="color: rgba(0,0,0,0.4); font-size: 12px; margin: 0;">Klicka för att kopiera</p>' +
            '</div>';
        }

        setTimeout(function () {
          overlay.classList.remove('is-active');
        }, 3000);
      });
    }
  }

  /* ==============================
     5. CTA CLICK TRACKING
     ============================== */

  function initCTATracking() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest(
        '.lp-hero__cta-primary, .lp-header__cta, .lp-offer__btn, .lp-sticky-cta__btn, .tt-hero__atc'
      );
      if (!btn) return;

      var label = btn.textContent.trim();
      var section = btn.closest('section');
      var sectionId = section ? section.id || section.className : 'unknown';

      trackEvent('LP_CTA_Click', { label: label, section: sectionId });
    });
  }

  /* ==============================
     6. ADD TO CART TRACKING
     ============================== */

  function initATCTracking() {
    document.querySelectorAll('.lp-offer__form, .tt-hero__form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var card = form.closest('.lp-offer__card');
        var isFeatured = card && card.classList.contains('lp-offer__card--featured');
        var title = card
          ? (card.querySelector('.lp-offer__card-title') || {}).textContent || ''
          : '';

        trackEvent('LP_Add_To_Cart', {
          product: title.trim(),
          type: isFeatured ? 'kit' : 'standalone'
        });

        if (window._learnq) {
          window._learnq.push(['track', 'LP Add To Cart', {
            product: title.trim(),
            type: isFeatured ? 'kit' : 'standalone',
            page: window.location.pathname
          }]);
        }
      });
    });
  }

  /* ==============================
     7. FAQ TRACKING
     ============================== */

  function initFAQTracking() {
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('.collapsible--heading, .accordion-trigger, details summary');
      if (!summary) return;

      var text = summary.textContent.trim().substring(0, 80);
      trackEvent('LP_FAQ_Open', { question: text });
    });
  }

  /* ==============================
     UTILS
     ============================== */

  function trackEvent(name, data) {
    // GA4 dataLayer
    if (window.dataLayer) {
      window.dataLayer.push({
        event: name,
        event_data: data || {}
      });
    }

    // Console in dev
    if (window.Shopify && window.Shopify.designMode) {
      console.log('[LP Track]', name, data);
    }
  }

  /* ==============================
     INIT
     ============================== */

  function init() {
    swapHeadlines();
    initScrollTracking();
    initStickyCTA();
    initExitIntent();
    initCTATracking();
    initATCTracking();
    initFAQTracking();

    // Track page view
    trackEvent('LP_View', {
      page: window.location.pathname,
      angle: new URLSearchParams(window.location.search).get('angle') || 'default',
      referrer: document.referrer
    });

    if (window._learnq) {
      window._learnq.push(['track', 'Viewed Landing Page', {
        page: 'skinroller-pro',
        angle: new URLSearchParams(window.location.search).get('angle') || 'default'
      }]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
